var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('BackButton',{staticClass:"header__back"}),_c('router-link',{staticClass:"header__title",attrs:{"to":"/"}},[_vm._v("School Log")]),_c('HeaderNav',{staticClass:"header__nav"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }